import { render, staticRenderFns } from "./CustomerUserNav.vue?vue&type=template&id=3728ce56"
import script from "./CustomerUserNav.vue?vue&type=script&lang=ts"
export * from "./CustomerUserNav.vue?vue&type=script&lang=ts"
import style0 from "./CustomerUserNav.vue?vue&type=style&index=0&id=3728ce56&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
